import styled from 'styled-components'

export const TextIcon = styled.div`
  flex-basis: 42px;
  margin-left: 0.625em;
`
